// @flow

import React, { Component, type Node } from "react";
import { bindAll, isEqual } from "lodash";
import type { UnaryFn } from "@tvg/types/Functional";
import type { RaceTypeCodeEnum } from "@tvg/types/Race";
import type { TabItem } from "@tvg/types/Common";

import TitleHeader from "../../_molecule/TitleHeader";
import TabGroup from "../../_molecule/TabGroup";
import Container from "./styled-components";

export type TabKey =
  | "infochanges"
  | "probables"
  | "pools"
  | "willpays"
  | "none";

type State = {
  selectedtab: TabKey
};

type Props = {
  /**
   * Default tab to display
   */
  defaultTab: TabKey,
  /**
   * Callback to be runed when user clicks a tab
   */
  onTabClick: UnaryFn<TabKey, boolean>,
  /**
   * Component to render inside
   */
  children: Node,
  /**
   * Race type code
   */
  raceTypeCode: RaceTypeCodeEnum,
  /**
   * Enables inline mode instead of modal ()
   */
  shouldRenderInline: boolean,
  /**
   * Sub title heading
   */
  subTitle: string,
  /**
   * Is Greyhound Race
   */
  isGreyhound: boolean
};

export default class PoolsNInfo extends Component<Props, State> {
  static defaultProps = {
    defaultTab: "infochanges",
    subTitle: "",
    onTabClick: () => true,
    raceTypeCode: "T",
    shouldRenderInline: false,
    isGreyhound: false
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedtab: this.props.defaultTab
    };

    bindAll(this, "buildTabs", "handleTabClick");
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.defaultTab !== this.state.selectedtab) {
      this.setState({ selectedtab: nextProps.defaultTab });
    }
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
  }

  buildTabs() {
    const tabs: TabItem[] = [
      {
        title: this.props.isGreyhound ? "Info" : "Info & Changes",
        isActive: this.state.selectedtab === "infochanges",
        onClick: () => {
          this.handleTabClick("infochanges");
        }
      },
      {
        title: "Probables",
        isActive: this.state.selectedtab === "probables",
        onClick: () => {
          this.handleTabClick("probables");
        }
      },
      {
        title: "Pools",
        isActive: this.state.selectedtab === "pools",
        onClick: () => {
          this.handleTabClick("pools");
        }
      },
      {
        title: "Will Pays",
        isActive: this.state.selectedtab === "willpays",
        onClick: () => {
          this.handleTabClick("willpays");
        }
      }
    ];

    return tabs;
  }

  handleTabClick(newTab: TabKey) {
    if (this.state.selectedtab !== newTab && this.props.onTabClick(newTab)) {
      this.setState({ selectedtab: newTab });
    }
  }

  render() {
    const tabs = this.buildTabs();

    return (
      <Container isInline={this.props.shouldRenderInline}>
        {this.props.shouldRenderInline && (
          <TitleHeader
            title="Pools & Info"
            subTitle={this.props.subTitle}
            subTitlePos="bottom"
            showTopBorder={!this.props.shouldRenderInline}
          />
        )}
        <TabGroup key="results-officials-tabs" tabs={tabs} />
        {this.props.children}
      </Container>
    );
  }
}
